export const graphiqlStyles = {
  '.graphiql-container .topBarWrap': {
    height: '47px',
  },
  '.graphiql-container .topBar': {
    height: '100%',
  },
  '.graphiql-operation-title-bar': {
    overflow: 'hidden',
  },
  '.graphiql-operation-title-bar > span > input': {
    width: 'auto !important',
  },
  '.graphiql-explorer-actions': {
    margin: '4px !important',
    width: 'auto !important',
  },
  '.graphiql-explorer-actions > select': {
    flexGrow: '0 ! important',
    marginRight: 'auto',
    marginLeft: '6px',
  },
  '.graphiql-explorer-root': {
    padding: '4px 4px 0 !important',
  },
  '.graphiql-container .doc-explorer-contents': {
    minWidth: '200px !important',
  },
  '.graphiql-container .query-pane-wrap': {
    background: 'white',
    boxShadow: '0 0 8px rgba(0, 0, 0, 0.15)',
    position: 'relative',
    zIndex: 3,
  },
  '.graphiql-container .query-title-bar': {
    cursor: 'default',
    display: 'flex',
    height: '34px',
    lineHeight: '14px',
    padding: '8px 8px 1px',
    position: 'relative',
    userSelect: 'none',
  },
  '.graphiql-container .query-title': {
    flex: 1,
    fontWeight: 'bold',
    overflowX: 'hidden',
    padding: '10px 0 10px 10px',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    userSelect: 'text',
    whiteSpace: 'nowrap',
  },
  '.graphiql-container .query-rhs': {
    position: 'relative',
  },
  '.graphiql-container .active-query': {
    background: '#f399d5',
  },
  // use `graphiql-explorer-simplified` to hide all action buttons and header from `graphiql-explorer`
  '.graphiql-explorer-simplified .graphiql-explorer-actions': {
    display: 'none !important',
  },
  '.graphiql-explorer-simplified .graphiql-explorer-root > div:last-child': {
    minHeight: '0 !important',
  },
  '.graphiql-explorer-simplified .doc-explorer-title-bar': {
    display: 'none !important',
  },
  '.graphiql-explorer-simplified .doc-explorer-contents': {
    top: 0,
    border: 'none',
  },
  '.graphiql-explorer-simplified .toolbar-button': {
    display: 'none !important',
  },
  '.graphiql-explorer-simplified .docExplorerWrap': {
    width: '100% !important',
    minWidth: '100% !important',
    boxShadow: 'none',
  },
  // use graphiql-simplified to hide cursor in `graphiql` pane
  '.graphiql-simplified .CodeMirror-gutters': {
    cursor: 'default !important',
  },
}
